import React from "react";
import { Typography } from "@mui/material";
import { fontSizes } from "../../theme/font-sizes";

const FieldLabel = ({ text }) => {
  return (
    <Typography
      fontSize={fontSizes.heading3}
      fontWeight={600}
      sx={{ mb: 2, mt: 3, textAlign: "left" }}
    >
      {text}
    </Typography>
  );
};

export default FieldLabel;
